import React from "react"
import { FaCode, FaPalette, FaRocket } from "react-icons/fa"

export default [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "web development",
    text: `I like to code things and enjoy bringing ideas to life in the browser.`,
  },
  {
    id: 2,
    icon: <FaPalette className="service-icon" />,
    title: "web design",
    text: `I value simple content structure, clean design patterns, and thoughtful interactions.`,
  },
  {
    id: 3,
    icon: <FaRocket className="service-icon" />,
    title: "mentoring",
    text: `I genuinely care about people, and love helping people map out their goals.`,
  },
]
